import { internal_getAcr } from '../control.internal.mjs';
import { ACP } from '../constants.mjs';
import '@rdfjs/data-model';
import '../../rdf.internal.mjs';
import 'http-link-header';
import 'n3';
import '../../rdfjs.mjs';
import { getThingAll } from '../../thing/thing.mjs';
import { getUrlAll } from '../../thing/get.mjs';
import 'cross-fetch';
import 'uuid';

//
/** @hidden */
function getAgentUrlAll(acr) {
    return Array.from(new Set(getThingAll(internal_getAcr(acr))
        .map((thing) => {
        return getUrlAll(thing, ACP.agent);
    })
        .reduce((flatArray, agentArray) => {
        return flatArray.concat(agentArray);
    }, [])));
}

export { getAgentUrlAll };
